/**
 * Builds a 7-entry grid-template-columns track array for one week row,
 * shrinking days without a workout so days with a workout can reclaim the
 * freed space via their own minmax()/1fr upper bound. Mirrors the array-
 * building half of CalendarMonth.js's calculateEmptyDayColumns; the "does
 * this day have a workout" derivation stays caller-specific since month and
 * week look at different date ranges/data shapes.
 *
 * @param {boolean[]} hasWorkoutFlags - exactly 7 entries for one week
 * @param {{ fullColumn: string, emptyColumn: string }} widths
 * @returns {string[] | null} null when every day is full or every day is
 *   empty (nothing to reclaim into) — caller should leave the ambient CSS
 *   grid-template-columns alone in that case.
 */
export function calculateDayColumnWidths(
  hasWorkoutFlags,
  { fullColumn, emptyColumn }
) {
  if (!Array.isArray(hasWorkoutFlags) || hasWorkoutFlags.length !== 7)
    return null;
  const busyCount = hasWorkoutFlags.filter(Boolean).length;
  if (busyCount === 7 || busyCount === 0) return null;
  return hasWorkoutFlags.map((hasWorkout) =>
    hasWorkout ? fullColumn : emptyColumn
  );
}
